
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';
import onClickOutside from 'react-onclickoutside';

import Translatable from '../../../Translatable';

import styles from '../styles.js';

class Dropdown extends Component {
    static propTypes = {
        dropdown: PropTypes.object.isRequired,
        dropdownLinkGroups: PropTypes.array.isRequired,
        toggleNavDropdown: PropTypes.func.isRequired
    }

    handleClickOutside() {
        const { dropdown, toggleNavDropdown } = this.props;
        if (dropdown.isVisible) {
            setTimeout(() => {
                toggleNavDropdown();
            }, 250);
        }
    }

    render() {
        const { dropdownLinkGroups } = this.props;
        return (
            <div className={css(styles.menu)}>
                <div className={css(styles.container)}>
                    <div className={css(styles.content)}>
                        <ul
                            role="tree"
                            className={css(styles.list)}
                        >
                            {dropdownLinkGroups.map(dropdownLinkGroup =>
                                dropdownLinkGroup.links.filter(link => link.shown).map(link => {
                                    return (
                                        <li
                                            key={shortid.generate()}
                                            role="treeitem"
                                        >
                                            <Translatable attributes={{ title: link.title }}>
                                                <a
                                                    href={link.url}
                                                    className={css(styles.container_link)}
                                                >
                                                    <div className={css(styles.content_baseline)}>
                                                        <div className={css(styles.container_table)}>
                                                            <div className={css(styles.container_table_child)}>
                                                                <div className={css(styles.text)}>
                                                                    <Translatable content={link.title} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </Translatable>
                                        </li>
                                    );
                                })
                            )}
                        </ul>
                    </div>
                    <svg
                        className={css(styles.fang)}
                        style={{ right: '20px' }}
                    >
                        <path
                            d="M0,10 20,10 10,0z"
                            className={css(styles.fangShape)}
                        />
                        <path
                            d="M0,10 10,0 20,10"
                            className={css(styles.fangStroke)}
                        />
                    </svg>
                </div>
            </div>
        );
    }
}

export default onClickOutside(Dropdown);



// WEBPACK FOOTER //
// ./src/components/Header/Nav/Dropdown/Dropdown.jsx